export default "__VITE_ASSET__11832606__"